// extracted by mini-css-extract-plugin
module.exports = {"requests":"requests__3-Xv4","title":"title__2ar_v","text":"text__2GTIR","link":"link__32hcG","count":"count__1G7mW","icon":"icon__3Q5rk","status":"status__DLrMN"};